import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { Router } from '@angular/router';
import { Session } from 'src/app/interfaces/session-data';
import { InitializeZapperPaymentResponse } from 'src/app/interfaces/zapper/InitializeZapperResponse';
import { ZapperUpdate } from 'src/app/interfaces/zapper/ZapperUpdate';
import { SessionService } from 'src/app/services/session/session.service';
import { ZapperServiceService } from 'src/app/services/zapper/zapper-service.service';
import zapper from 'zapperjs';

@Component({
  selector: 'app-zapper-version-two',
  templateUrl: './zapper.component.html',
  styleUrls: ['./zapper.component.scss']
})
export class ZapperComponent implements OnInit {

  // loader
  color: ThemePalette = 'primary';
  value = 50;
  diameter = 60;

  public loading = true;
  public session: Session;
  public paymentMethod = 'zapper';
  otpState = false;
  timeRemaining = this.checkTime();
  mobile;
  secondCountdown = this.checkTimeSeconds();
  timeRemainingInterval;
  headerColor;
  htmlZapperImgEl: HTMLImageElement;
  htmlZapperGifEl: HTMLImageElement;

  cancelTransaction() {
    this.router.navigate([`${this.sessionService.getVirtualTwoBaseurl()}/transaction-status/userCancelled`]);
  }

  checkTimeSeconds() {
    if (sessionStorage.getItem('session-token-time') !== sessionStorage.getItem('sessionToken')) {
      return 0;
    } else {
      return parseInt(sessionStorage.getItem('session-time-seconds'), 10);
    }
  }

  checkTime() {
    if (sessionStorage.getItem('session-token-time') !== sessionStorage.getItem('sessionToken')) {
      return 1800;
    } else {
      return parseInt(sessionStorage.getItem('session-time'), 10);
    }
  }

  constructor(
    private breakpointObserver: BreakpointObserver,
    private zapperService: ZapperServiceService,
    private router: Router,
    private sessionService: SessionService
    ) {
    sessionStorage.setItem('selected-payment', 'zapper');
    this.session = JSON.parse(sessionStorage.getItem('sessionData'));
    breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.mobile = result.matches;
    });

    this.timeRemainingInterval = setInterval(() => {
      sessionStorage.setItem('session-token-time', sessionStorage.getItem('sessionToken'));
      if (this.timeRemaining === 0) {
        clearInterval(this.timeRemainingInterval);
        this.router.navigate([`${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`]);
      }
      // Decrement time remaining in 1s intervals
      this.timeRemaining -= 1;
      // Change e.g 4:00 next count to 3:59 and don't decrement afterwards,
      // I suppose it could be changed to 60 and decremented but ¯\_(ツ)_/¯
      if (this.secondCountdown === 0) {
        this.secondCountdown = 59;
      } else {
        this.secondCountdown -= 1;
      }
      sessionStorage.setItem('session-time', this.timeRemaining.toString());
      sessionStorage.setItem('session-time-seconds', this.secondCountdown.toString());
    }, 1000);
  }

  uxFriendlyTime(time: number) {
    return `${Math.floor(time / 60)}:${this.secondCountdown.toString().length <= 1 ? '0' + this.secondCountdown.toString() : this.secondCountdown.toString()}`;
  }

  getTimeRemaining(timeRemaining) {
    this.timeRemaining = timeRemaining;
    this.otpState = true;
  }

  ngOnInit(): void {
    sessionStorage.setItem('TRANSACTION_CONFIRMED_PAYMENT_METHOD', this.paymentMethod);
    this.zapperService.initializeZapperTransaction(sessionStorage.getItem('sessionToken'))
    .subscribe((data: InitializeZapperPaymentResponse) => {
      const paymentWidget = new zapper.payments.PaymentWidget(
            '.zapper',
            {
                merchantId: data.merchantId,
                siteId: data.siteId,
                amount: this.session.sessionDisplayInformation.amount,
                reference: data.transactionUid
            }
      );
      this.loading = false;
      this.htmlZapperImgEl = document.getElementById('zapper_virtual').getElementsByClassName('logo')[0].getElementsByTagName('img')[0];
      this.htmlZapperImgEl.src =   '../../../assets/icons/zapper-logo.svg';
      paymentWidget.on('payment', ({ status, paidAmount, zapperId, reference }) => {
        let multipliedAmount = paidAmount*100;
        const updateObject: ZapperUpdate = {
          status,
          zapperId,
          paidAmount: multipliedAmount,
          reference
        };
        if (status === 2) {
          setTimeout(() => {
            this.htmlZapperGifEl = document.getElementsByClassName('qrcode')[0].children[0].getElementsByTagName('img')[0];
            this.htmlZapperGifEl.src = '../../../assets/icons/tick-successful.gif';
          }, 1);
          this.zapperService.updateZapperTransaction(sessionStorage.getItem('sessionToken'), updateObject)
            .subscribe((data) => {
              this.router.navigate([`${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`]);
            }, (error) => {
              this.router.navigate([`${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`]);
            });
        } else {
          // Do nothing basically, allow user to scan multiple times, possibly converting to a successful transaction, but if not it will eventually result in a timeout which is fine
        }
      });
    }, (error) => {
      this.router.navigate([`${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`]);

    });
  }
}
